import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { postData, getData } from "../../../../ApiServices/ApiService";
import {
    ORG_GET_SERVICE_LIST_SEARCH, ORG_GET_SUB_SERVICE_LIST_SEARCH,
    ORG_GET_SCHEDULE_REPORT, ORG_OVERVIEW_REPORT, ORG_TASK_STATUS, ORG_DATE_STATUS, ORG_CHECKWISE_STATUS, ORG_GET_NOTIFICATIONS_LIST_DASHBOARD, ORG_GET_GROUP_LIST, ORG_GET_ALL_CODES_LIST
} from "../../../../ApiServices/BaseURL";
import { useTheme } from "../../../../GlobalContext/GlobalContext";
import { logFrontendException } from "../../../../Utils/Exception";

const GstServiceController = () => {
    const [serviceOptions, setServiceOptions] = useState([]);
    const [serviceSubOptions, setServiceSubOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([
        { label: "Completed", value: 3 },
        { label: "Pending", value: 8 },
    ]);
    const [taskOverview, setTaskOverview] = useState([
        { label: "Completed", key: "completed", value: "--" },
        { label: "Priority", key: "priority", value: "--" },
        { label: "In Progress", key: "inprogress", value: "--" },
        { label: "Not Started", key: "not_started", value: "--" },
        { label: "Hold", key: "hold", value: "--" },
        { label: "Delayed", key: "delayed", value: "--" },
        { label: "Long Due", key: "long_due", value: "--" },
    ]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [servicesLoading, setServicesLoading] = useState(false);
    const [servicesError, setServicesError] = useState('');
    const [serviceName, setServiceName] = useState('');
    const [subServiceName, setSubServiceName] = useState('');
    const [subServicesLoading, setSubServicesLoading] = useState(false);
    const [subServicesError, setSubServicesError] = useState('');
    const [overViewLoading, setOverViewLoading] = useState(false);
    const [overViewReportError, setOverViewReportError] = useState('');
    const [taskStatus, setTaskStatus] = useState([
        { label: "Task with Pending Issues", key: "task_with_pending_issues", value: "--" },
        { label: "Tasks kept on Hold", key: "tasks_kept_on_hold", value: "--" },
        { label: "Tasks with No Issues", key: "tasks_with_no_issues", value: "--" },
    ]);
    const [taskStatusLoading, setTaskStatusLoading] = useState(false);
    const [taskStatusError, setTaskStatusError] = useState('');
    const [dateStatus, setDatetatus] = useState([
        { label: "Due by Today", key: "due_by_today", value: "--" },
        { label: "Due within 7 Days", key: "due_within_7_days", value: "--" },
        { label: "Crossed Due Date", key: "crossed_due_date", value: "--" },
    ]);
    const [dateStatusLoading, setDateStatusLoading] = useState(false);
    const [dateStatusError, setDateStatusError] = useState('');
    const [checkwiseStatusList, setCheckwiseStatusList] = useState([])
    const [checkwiseStatus, setCheckwiseStatus] = useState([
        { label: "Info received from client for GSTR1", key: "info_received_from_clients_for_gstr1", value: "--" },
        { label: "Preparation of GSTR1", key: "preparation_of_gstr1", value: "--" },
        { label: "Checking for GSTR1", key: "checking_for_gstr1", value: "--" },
        { label: "Submission of GStr1", key: "submission_of_gstr1", value: "--" },
        { label: "Filling GSTR1", key: "filling_gstr1", value: "--" },
    ]);
    const [checkwiseStatusLoading, setCheckwiseStatusLoading] = useState(false);
    const [checkwiseStatusError, setCheckwiseStatusError] = useState('');
    const [scheduleInfoListLoading, setScheduleInfoListLoading] = useState([
        { label: "Follow Ups", key: "due_by_today", value: "--" },
        { label: "Appointments", key: "due_within_7_days", value: "--" },
        { label: "Meetings", key: "crossed_due_date", value: "--" },
    ]);
    const { setIsLoginPopup } = useTheme();
    const [taskCheckList, setTaskCheckList] = useState([])
    const [taskCheckLoading, setTaskCheckLoading] = useState(false)
    const [taskCheckError, setTaskCheckError] = useState('')
    const [scheduleInfoList, setScheduleInfoList] = useState([]);
    const [scheduleResError, setScheduleResError] = useState('');
    const [scheduleLoading, setScheduleLoading] = useState(false);

    const [selectedService, setSelectedService] = useState(null);
    const [selectedServiceCategory, setSelectedServiceCategory] = useState(null);

    const [grouperror, setGroupError] = useState('');
    const [groupListLoading, setGroupListLoading] = useState(false);
    const groupClientOptionsRef = useRef([]);
    const [groupClientOptions, setGroupClientOptions] = useState([]);
    const [yearListLoading, setYearListLoading] = useState(false);
    const [yearListError, setYearListError] = useState('');
    const [yearList, setYearList] = useState([]);
    const [periodList, setPeriodList] = useState([]);

    const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
    const [selectedFinancialStatus, setSelectedFinancialStatus] = useState("");
    const [selectedUserwiseStatus, setSelectedUserwiseStatus] = useState("");
    const [selectedUserwiseCheck, setSelectedUserwiseCheck] = useState("");
    const [selectedOverallStatus, setSelectedOverallStatus] = useState("");
    const [selectedOverallCheck, setSelectedOverallCheck] = useState("");
    const [selectedOverallYear, setSelectedOverallYear] = useState("");
    const [selectedOverallPeriod, setSelectedOverallPeriod] = useState("");
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [selectedTaskwiseCheck, setSelectedTaskwiseCheck] = useState(null);
    const [selectedTaskCheck, setSelectedTaskCheck] = useState(null)
    const [selectedTaskCheck2, setSelectedTaskCheck2] = useState(null);

    const [countError, setCountError] = useState('');
    const [count, setCount] = useState('--');
    const [countLoading, setCountLoading] = useState(false);

    const [toDoLoading, setToDoLoading] = useState(false);
    const [toDoReportError, setToDoReportError] = useState('');

    const [userPermissions, setUserPermissions] = useState(null);

     const pageName = 'GSTServiceController';
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

    useEffect(() => {
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
        setUserPermissions(storedUserInfo?.user_permissions || {});
    }, [])

    const handleCompletedCount = (value) => {
        setSelectedTaskCheck(value);
        fetchUserCount(value, selectedTaskCheck2);
    }

    const handlePendingCount = (value) => {
        setSelectedTaskCheck2(value);
        fetchUserCount(selectedTaskCheck, value);
    }

    const cards = [
        {
            title: "Financial Year Report",
            dropdowns: [
                { label: "Financial Year", options: yearList, loading: yearListLoading, error: yearListError, value: selectedFinancialYear, setValue: setSelectedFinancialYear, dropdownWidth: '70px' },
                { label: "Financial Status", options: statusOptions, loading: false, error: "", value: selectedFinancialStatus, setValue: setSelectedFinancialStatus, dropdownWidth: '84px' },
            ],
        },
    ]
    const cards2 = [
        {
            title: "Userwise Task at a Glance",
            dropdowns: [
                { label: "Userwise Status", options: taskCheckList, loading: taskCheckLoading, error: taskCheckError, value: selectedTaskCheck, setValue: setSelectedTaskCheck, function: handleCompletedCount, placeholder: "Completed Checks", dropdownWidth: '150px' },
                { label: "Userwise Checks", options: taskCheckList, loading: taskCheckLoading, error: taskCheckError, value: selectedTaskCheck2, setValue: setSelectedTaskCheck2, function: handlePendingCount, placeholder: "Pending Checks", dropdownWidth: '130px' },
            ],
        },
    ]
    const cards3 = [
        {
            title: "Overall Task at a Glance",
            dropdowns: [
                { label: "Overall Status", options: taskCheckList, loading: taskCheckLoading, error: taskCheckError, value: selectedOverallStatus, setValue: setSelectedOverallStatus, placeholder: "Completed Checks", dropdownWidth: '110px' },
                { label: "Overall Checks", options: taskCheckList, loading: taskCheckLoading, error: taskCheckError, value: selectedOverallCheck, setValue: setSelectedOverallCheck, placeholder: "Pending Checks", dropdownWidth: '110px' },
                { label: "Overall Year", options: yearList, loading: yearListLoading, error: yearListError, value: selectedOverallYear, setValue: setSelectedOverallYear, placeholder: "Select", dropdownWidth: '70px' },
                { label: "Overall Period", options: periodList, loading: yearListLoading, error: yearListError, value: selectedOverallPeriod, setValue: setSelectedOverallPeriod, placeholder: "Select", dropdownWidth: '84px' },
            ],
        },
    ];

    const cards1 = [
        {
            title: "Taskwise Group Report",
            dropdowns: [
                { label: "Group Name", options: groupClientOptions, loading: groupListLoading, error: grouperror, value: selectedGroup, setValue: setSelectedGroup, placeholder: "Group Name", dropdownWidth: '95px' },
                { label: "TaskWise Status", options: statusOptions, loading: false, error: "", value: selectedTaskwiseCheck, setValue: setSelectedTaskwiseCheck, placeholder: "Select", dropdownWidth: '84px' },
            ],
        },
    ];

    const [toDoListData, setToDoListData] = useState([
        { taskStatus: "Completed", taskwise: "--", fileNo: "--", without: "--" },
        { taskStatus: "Pending", taskwise: "--", fileNo: "--", without: "--" },
    ]);

    const handleToDoNavigation = (source, status) => {
        navigate('/to-do', {
          state: {
            source,
            status,
          }
        });
      };

    const fetchServices = async () => {
        setServicesLoading(true);
        setServiceOptions([]);
        setServicesError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
            };

            // API call to fetch GST services
            const response = await postData(ORG_GET_SERVICE_LIST_SEARCH, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const services = responseData?.dataJ.map((service) => ({
                            label: service.service_name,
                            value: service.service_id,
                        }));
                        setServiceOptions(services);
                        handleSubServices(services[0], 'firstTime')
                    } else {
                        setServicesError(responseData?.info || 'Service search failed.');
                        logFrontendException(storedUserId, pageName, "fetchService", responseData?.info || '');
                    }
                } else {
                    setServicesError(responseData?.info || 'Unexpected response code from the server.');
                    logFrontendException(storedUserId, pageName, "fetchService", responseData?.info || '');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
               
                    setServicesError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "fetchService", responseData || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                
                setIsLoginPopup(true)
            }
            
            // Unexpected or network-related errors
            else {
                setServicesError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "fetchService", responseData || '');
            }
        } catch (error) {
            
                setServicesError(`Failed to search service options. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "fetchService-catch", error || '');
            
        } finally {
            setServicesLoading(false);
        }
    };

    const fetchSubServices = async (serviceId, defaultvalue) => {
        setSubServicesLoading(true);
        setServiceSubOptions([]);
        setSubServiceName('');
        setSubServicesError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                service_id: serviceId,
            };

            // API call to fetch GST services
            const response = await postData(ORG_GET_SUB_SERVICE_LIST_SEARCH, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const subServices = responseData?.dataJ.map((service) => ({
                            label: service.service_sub_name,
                            value: service.service_sub_id,
                        }));
                        setServiceSubOptions(subServices);
                        if (defaultvalue === 'firstTime') {
                            const Services = {
                                label: '',
                                value: serviceId,
                            };
                            handleData(Services, subServices[0])
                        }
                    } else {
                        setSubServicesError(responseData?.info || 'Subservice search failed.');
                        logFrontendException(storedUserId, pageName, "fetchSubService", responseData?.info || '');
                    }
                } else {
                    setSubServicesError(responseData?.info || 'Unable to fetch services');
                    logFrontendException(storedUserId, pageName, "fetchSubService", responseData?.info || '');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                
                    setSubServicesError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "fetchSubService", responseData || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                
                setIsLoginPopup(true)
            }
           
            // Unexpected or network-related errors
            else {
                setSubServicesError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "fetchSubService", responseData || '');
            }
        } catch (error) {

                setSubServicesError(`Failed to search subservice options. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "fetchSubService-catch", error || '');
            
        } finally {
            setSubServicesLoading(false);
        }
    };

    const overViewReport = async (serviceName, subServiceName) => {
        setOverViewLoading(true);
        setOverViewReportError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                service_id: serviceName?.value,
                service_sub_id: subServiceName?.value,
                action: "overview_report"
            };

            // API call to fetch GST services
            const response = await postData(ORG_OVERVIEW_REPORT, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const responseDataObject = responseData?.dataJ[0] || {};
                        const overViewReport = taskOverview.map((task) => ({
                            ...task,
                            value: responseDataObject[task.key] ?? "--",
                        }));
                        setTaskOverview(overViewReport);
                    } else {
                        setOverViewReportError(responseData?.info || 'Task overview status failed.');
                        logFrontendException(storedUserId, pageName, "overViewReport", responseData?.info || '');
                    }
                } else {
                    setOverViewReportError(responseData?.info || 'Unable to fetch task overview');
                    logFrontendException(storedUserId, pageName, "overViewReport", responseData?.info || '');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                
                    setOverViewReportError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "overViewReport", responseData || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                
                setIsLoginPopup(true)
            }
            
            // Unexpected or network-related errors
            else {
                setOverViewReportError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "overViewReport", responseData || '');
            }
        } catch (error) {
            
                setOverViewReportError(`Failed to get task overview. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "overViewReport-catch", error || '');
            
        } finally {
            setOverViewLoading(false);
        }
    }

    const taskStatusReport = async (serviceName, subServiceName) => {
        setTaskStatusLoading(true);
        setTaskStatusError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                service_id: serviceName?.value,
                service_sub_id: subServiceName?.value,
                action: "task_with_status"
            };

            // API call to fetch GST services
            const response = await postData(ORG_OVERVIEW_REPORT, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const responseDataObject = responseData?.dataJ[0] || {};
                        const taskStatusReport = taskStatus.map((task) => ({
                            ...task,
                            value: responseDataObject[task.key] ?? "--",
                        }));
                        setTaskStatus(taskStatusReport);
                    } else {
                        setTaskStatusError(responseData?.info || 'Task status failed.');
                        logFrontendException(storedUserId, pageName, "taskStatusReport", responseData?.info || '');
                    }
                } else {
                    setTaskStatusError(responseData?.info || 'Unable to fetch task status');
                    logFrontendException(storedUserId, pageName, "taskStatusReport", responseData?.info || '');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                
                    setTaskStatusError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "taskStatusReport", responseData || '');
                
                setIsLoginPopup(true)
            }
            
            // Unexpected or network-related errors
            else {
                setTaskStatusError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "taskStatusReport", responseData || '');
            }
        } catch (error) {
            
                setTaskStatusError(`Failed to get task status. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "taskStatusReport-catch", error || '');
            
        } finally {
            setTaskStatusLoading(false);
        }
    }

    const dateReport = async (serviceName, subServiceName) => {
        setDateStatusLoading(true);
        setDateStatusError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                service_id: serviceName?.value,
                service_sub_id: subServiceName?.value,
                action: "task_with_dates"
            };

            // API call to fetch GST services
            const response = await postData(ORG_OVERVIEW_REPORT, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const responseDataObject = responseData?.dataJ[0] || {};
                        const dateStatusReport = dateStatus.map((task) => ({
                            ...task,
                            value: responseDataObject[task.key] ?? "--",
                        }));
                        setDatetatus(dateStatusReport);
                    } else {
                        setDateStatusError(responseData?.info || 'Date status failed.');
                        logFrontendException(storedUserId, pageName, "dateReport", responseData?.info || '');
                    }
                } else {
                    setDateStatusError(responseData?.info || 'Unable to fetch task with due dates');
                    logFrontendException(storedUserId, pageName, "dateReport", responseData?.info || '');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                
                    setDateStatusError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "dateReport", responseData || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                
                setIsLoginPopup(true)
            }
           
            // Unexpected or network-related errors
            else {
                setDateStatusError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "dateReport", responseData || '');
            }
        } catch (error) {
            
                // An error occurred in setting up the request
                setDateStatusError(`Failed to get date status. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "dateReport-catch", error || '');
            
        } finally {
            setDateStatusLoading(false);
        }
    }

    const fetchScheduleInfo = async () => {
        setScheduleLoading(true);
        setScheduleResError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                // "emp_id_auth": "10001",
                // "service_id": "10006",
                // "service_sub_id": "10006"
            };

            // API call to fetch GST services
            const response = await postData(ORG_GET_SCHEDULE_REPORT, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        if (responseData?.dataJ?.length > 0) {
                            setScheduleInfoList(responseData?.dataJ);
                        } else {
                            setScheduleResError(responseData?.info || 'No schedule info available.');
                            logFrontendException(storedUserId, pageName, "sceduleInfo", responseData?.info || '');
                        }

                    } else {
                        setScheduleResError(responseData?.info || 'Schedule Info failed.');
                        logFrontendException(storedUserId, pageName, "sceduleInfo", responseData?.info || '');
                    }
                } else {
                    setScheduleResError(responseData?.info || 'Unable to fetch schedule info.');
                    logFrontendException(storedUserId, pageName, "sceduleInfo", responseData?.info || '');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                
                    setScheduleResError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "sceduleInfo", responseData || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
            
            // Unexpected or network-related errors
            else {
                setScheduleResError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "sceduleInfo", responseData || '');
            }
        } catch (error) {
            
                setScheduleResError(`Failed to get Schedule Info. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "sceduleInfo-catch", error || '');
            
        } finally {
            setScheduleLoading(false);
        }
    }

    const checkwiseReport = async (serviceName, subServiceName) => {
        setCheckwiseStatusLoading(true);
        setCheckwiseStatusError('');
        setCheckwiseStatusList([]);
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                service_id: serviceName?.value,
                service_sub_id: subServiceName?.value,
                action: "checkwise_report"
            };

            // API call to fetch GST services
            const response = await postData(ORG_OVERVIEW_REPORT, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const responseDataObject = responseData?.dataJ[0] || {};
                        const checkwiseStatusReport = checkwiseStatus.map((task) => ({
                            ...task,
                            value: responseDataObject[task.key] ?? "--",
                        }));
                        // setCheckwiseStatus(checkwiseStatusReport);
                        setCheckwiseStatusList(responseData?.dataJ);
                    } else {
                        setCheckwiseStatusError(responseData?.info || 'Checkwise report failed.');
                        logFrontendException(storedUserId, pageName, "checkwiseReport", responseData?.info || '');
                    }
                } else {
                    setCheckwiseStatusError(responseData?.info || 'Unable to fetch checkwise pending tasks.');
                    logFrontendException(storedUserId, pageName, "checkwiseReport", responseData?.info || '');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
               
                    setCheckwiseStatusError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "checkwiseReport", responseData || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                
                setIsLoginPopup(true)
            }
            
            // Unexpected or network-related errors
            else {
                setCheckwiseStatusError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "checkwiseReport", responseData || '');
            }
        } catch (error) {
            
                setCheckwiseStatusError(`Failed to get checkwise status. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "checkwiseReport", error || '');
            
        } finally {
            setCheckwiseStatusLoading(false);
        }
    }

    const fetchTaskCheckList = async (serviceName, subServiceName) => {
        setTaskCheckLoading(true);
        setTaskCheckError('');
        setTaskCheckList([]);
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                service_id: serviceName?.value,
                service_sub_id: subServiceName?.value
            };

            // API call to fetch GST services
            const response = await postData(ORG_GET_SERVICE_LIST_SEARCH, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const services = responseData?.dataJ.map((service) => ({
                            label: service.service_check_name,
                            value: service.service_check_id,
                        }));
                        // setCheckwiseStatus(checkwiseStatusReport);
                        setTaskCheckList(services);
                    } else {
                        setTaskCheckError(responseData?.info || 'Checkwise report failed.');
                        logFrontendException(storedUserId, pageName, "fetchTaskCheckList", responseData?.info || '');
                    }
                } else {
                    setTaskCheckError(responseData?.info || 'Unable to fetch task check list.');
                    logFrontendException(storedUserId, pageName, "fetchTaskCheckList", responseData?.info || '');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                
                    setTaskCheckError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "fetchTaskCheckList", responseData?.info || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
            
            // Unexpected or network-related errors
            else {
                setTaskCheckError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "fetchTaskCheckList", responseData?.info || '');
            }
        } catch (error) {
            
                setTaskCheckError(`Failed to get task check. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "fetchTaskCheckList-catch", error || '');
            
        } finally {
            setTaskCheckLoading(false);
        }
    }

    const handleSubServices = (serviceName, defaultvalue) => {
        setServiceName(serviceName);
        setSelectedService(serviceName);
        fetchSubServices(serviceName?.value, defaultvalue);
        clearReportInfo();
    };

    const handleData = (serviceName, subServiceName) => {
        console.log('serviceName:', subServiceName)
        setSubServiceName(subServiceName);
        setSelectedServiceCategory(subServiceName);
        overViewReport(serviceName, subServiceName);
        taskStatusReport(serviceName, subServiceName);
        dateReport(serviceName, subServiceName);
        checkwiseReport(serviceName, subServiceName);
        fetchTaskCheckList(serviceName, subServiceName);
        toDoReport(serviceName, subServiceName);
    }

    useEffect(() => {
        //console.log("serviceName", serviceName);
        fetchServices();
        fetchGroupList();
        fetchYearList();
        fetchScheduleInfo();
        fetchNotificationstsList();
        setSelectedFinancialStatus(statusOptions[0]); // default for status
        setSelectedTaskwiseCheck(statusOptions[0]); // default for status
    }, []);

    const handlePendingTask = (type, taskData) => {
        console.log('handlePendingTask taskData :', taskData, 'selectedService', selectedService?.value);
        if (taskData?.value !== '--' && taskData?.value > 0) {
            const selectedInfo = {
                selService: selectedService || null,
                selServiceCategory: selectedServiceCategory || null,
                taskType: type || '',
                taskTypeName: taskData?.key || '',
                serviceCheckId: 0
            }
            navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
        }
    }

    const handleCheckwise = (type, taskData) => {
        console.log('handleCheckwise taskData :', taskData, 'selectedService', selectedService?.value);
        if (taskData?.task_check_count !== '--' && taskData?.task_check_count > 0) {
            const selectedInfo = {
                selService: selectedService || null,
                selServiceCategory: selectedServiceCategory || null,
                taskType: type || '',
                taskTypeName: taskData?.service_check_name || '',
                serviceCheckId: taskData?.service_check_id || 0
            }
            console.log('handleSchedule selectedInfo : ', selectedInfo)
            navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
        }
    }

    const handleSchedule = (type, taskData) => {
        console.log('handleSchedule taskData :', taskData, 'selectedService', selectedService?.value);
        // if (taskData?.sc_count === '--' && taskData?.sc_count > 0) {
        //     const selectedInfo = {
        //         selService: selectedService?.value || 0,
        //         selServiceCategory: selectedServiceCategory?.value || 0,
        //         taskType: type || '',
        //         taskTypeName: taskData?.key || ''

        //     }
        //     console.log('handleSchedule selectedInfo : ',selectedInfo)
        //     // navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
        // }


        navigate('/schedule-reminder');
    }

    const handleFinancialYear = (type) => {
        console.log('selectedService', selectedService?.value);
        // if (userPermissions?.services?.per_name_sub_json?.view_task === 1) {
            const selectedInfo = {
                selService: selectedService || null,
                selServiceCategory: selectedServiceCategory || null,
                taskType: type || '',
                serviceCheckId: 0,
                financialYear: selectedFinancialYear,
                taskStatus: selectedFinancialStatus,
            }
            navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
        // }
    }

    const handleTaskwise = (type) => {
        console.log('selectedService', selectedService?.value);
        // if (userPermissions?.services?.per_name_sub_json?.view_task === 1) {
            const selectedInfo = {
                selService: selectedService || null,
                selServiceCategory: selectedServiceCategory || null,
                taskType: type || '',
                groupId: selectedGroup,
                taskStatus: selectedTaskwiseCheck,
            }
            navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
        // }
    }

    const [notificationLoading, setNotificationLoading] = useState(false);
    const [notificationError, setNotificationError] = useState('');
    const [notificationList, setNotificationList] = useState([])
    const fetchNotificationstsList = async () => {
        try {
            setNotificationLoading(true);
            setNotificationError('');
            setNotificationList([])
            // setTeamInfo({});
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_NOTIFICATIONS_LIST_DASHBOARD}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            const fetchedList = responseData?.dataJ
                            setNotificationList(fetchedList);
                            // selTeamInfo.current = responseData?.dataJ[0];
                        } else {
                            setNotificationError(responseData?.info || 'Data Not Found');
                            logFrontendException(storedUserId, pageName, "notificationList", responseData?.info || '');
                        }
                    } else {
                        setNotificationError(responseData?.info || 'Failed to fetch  todo list. Please try again.');
                        logFrontendException(storedUserId, pageName, "notificationList", responseData?.info || '');
                    }
                } else {
                    setNotificationError(responseData?.info || 'Failed to fetch todo list.');
                    logFrontendException(storedUserId, pageName, "notificationList", responseData?.info || '');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                
                    setNotificationError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "notificationList", responseData || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                
                setIsLoginPopup(true)
            }
           
            // Unexpected or network-related errors
            else {
                setNotificationError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "notificationList", responseData || '');
            }
        } catch (error) {
           
                setNotificationError(`Failed to fetch todo list. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "notificationList-catch", error || '');
            
        } finally {
            setNotificationLoading(false);
        }
    }

    const fetchGroupList = async () => {
        try {
            setGroupListLoading(true);
            // setFieldConfigs((prevConfigs) =>
            //     prevConfigs.map((field) =>
            //         field.key === "group_name"
            //             ? { ...field, loading: true }
            //             : field
            //     )
            // );
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_GROUP_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            // Transforming the data
                            groupClientOptionsRef.current = await responseData?.dataJ.map(service => ({
                                label: service.group_name,
                                value: service.group_id
                            }));
                            setGroupClientOptions(groupClientOptionsRef.current)
                            // Update the fieldConfigs dynamically
                            // setFieldConfigs((prevConfigs) =>
                            //     prevConfigs.map((field) =>
                            //         field.key === "group_name"
                            //             ? { ...field, options: groupClientOptionsRef.current }
                            //             : field
                            //     )
                            // );
                        } else {
                            setGroupError(responseData?.info || 'Data Not Found');
                            logFrontendException(storedUserId, pageName, "groupList", responseData?.info || '');
                        }
                    } else {
                        setGroupError(responseData?.info || 'Failed to fetch data. Please try again.');
                        logFrontendException(storedUserId, pageName, "groupList", responseData?.info || '');
                    }
                } else {
                    setGroupError(responseData?.info || 'Something went wrong while processing your request.');
                    logFrontendException(storedUserId, pageName, "groupList", responseData?.info || '');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                
                    setGroupError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "groupList", responseData || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                
                setIsLoginPopup(true)
            }
            
            
            // Unexpected or network-related errors
            else {
                setGroupError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            
                setGroupError(`Something went wrong while processing your request. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "groupList-catch", error || '');
            
        } finally {
            setGroupListLoading(false);
            // setFieldConfigs((prevConfigs) =>
            //     prevConfigs.map((field) =>
            //         field.key === "group_name"
            //             ? { ...field, loading: false }
            //             : field
            //     )
            // );
        }
    }

    const fetchYearList = async () => {
        try {
            setYearListLoading(true);
            setYearListError('')
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const payLoad = { "code_id": "org_all_codes" }
            const response = await postData(ORG_GET_ALL_CODES_LIST, payLoad);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ) {
                            // Transforming the data
                            const yearListOptions = await responseData?.dataJ?.financial_year_codes_list.map(service => ({
                                label: service?.year_name,
                                value: service?.year_id,
                                isDefault: service?.is_default === 1
                            }));
                            setYearList(yearListOptions);

                            const defaultYear = yearListOptions.find(year => year.isDefault);
                            setSelectedFinancialYear(defaultYear || null); // setting default current financial year
                            setSelectedOverallYear(defaultYear || null); // setting default current financial year
                        
                            // Transforming the data
                            const periodOption = await responseData?.dataJ?.financial_period_codes_list.map(service => ({
                                label: service.pc_name,
                                value: service.pc_id
                            }));
                            setPeriodList(periodOption)
                            setSelectedOverallPeriod(periodOption[0]);
                        } else {
                            setYearListError(responseData?.info || 'Data Not Found');
                            logFrontendException(storedUserId, pageName, "yearList", responseData?.info || '');
                        }
                    } else {
                        setYearListError(responseData?.info || 'Failed to fetch financial year. Please try again.');
                        logFrontendException(storedUserId, pageName, "yearList", responseData?.info || '');
                    }
                } else {
                    setYearListError(responseData?.info || 'Failed to fetch financial year.');
                    logFrontendException(storedUserId, pageName, "yearList", responseData?.info || '');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                
                    setYearListError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "yearList", responseData || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                
                setIsLoginPopup(true)
            }
           
            // Unexpected or network-related errors
            else {
                setYearListError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "yearList", responseData || '');
            }
        } catch (error) {
            
                setYearListError(`Failed to fetch financial year. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "yearList-catch", error || '');
            
        } finally {
            setYearListLoading(false);
        }
    }

    const fetchUserCount = async (selectedTaskCheck, selectedTaskCheck2) => {
        //console.log('get client')
        try {
            setCount('--');
            setCountError('');
            setCountLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const payLoad = {
                "emp_id_auth": storedUserInfo?.emp_id,
                "service_id": selectedService?.value || 0,
                "service_sub_id": selectedServiceCategory?.value || 0,
                "action": "userwise_report",
                "completed_check_id": selectedTaskCheck?.value || 0,
                "pending_check_id": selectedTaskCheck2?.value || 0,
            }
            const response = await postData(ORG_OVERVIEW_REPORT, payLoad);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            setCount(responseData?.dataJ[0]?.task_count);
                        } else {
                            setCountError(responseData?.info || 'No task available.');
                            logFrontendException(storedUserId, pageName, "fetchUserCount", responseData?.info || '');
                        }
                    } else {
                        setCountError(responseData?.info || 'Failed to fetch tasks. Please try again.');
                        logFrontendException(storedUserId, pageName, "fetchUserCount", responseData?.info || '');
                    }
                } else {
                    setCountError(responseData?.info || 'Failed to fetch tasks.');
                    logFrontendException(storedUserId, pageName, "fetchUserCount", responseData?.info || '');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                
                    setCountError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "fetchUserCount", responseData || '');
                
                setIsLoginPopup(true)
            } else {
                setCountError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "fetchUserCount", responseData || '');
            }
        } catch (error) {
           
                setCountError(`Failed to fetch tasks. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "fetchUserCount-catch", error || '');
            
        } finally {
            setCountLoading(false);
        }
    }

    const clearReportInfo = () => {
        setTaskOverview([
            { label: "Completed", key: "completed", value: "--" },
            { label: "Priority", key: "priority", value: "--" },
            { label: "In Progress", key: "inprogress", value: "--" },
            { label: "Not Started", key: "not_started", value: "--" },
            { label: "Hold", key: "hold", value: "--" },
            { label: "Delayed", key: "delayed", value: "--" },
            { label: "Long Due", key: "long_due", value: "--" },
        ])
        setTaskStatus([
            { label: "Task with Pending Issues", key: "task_with_pending_issues", value: "--" },
            { label: "Tasks kept on Hold", key: "tasks_kept_on_hold", value: "--" },
            { label: "Tasks with No Issues", key: "tasks_with_no_issues", value: "--" },
        ])
        setDatetatus([
            { label: "Due by Today", key: "due_by_today", value: "--" },
            { label: "Due within 7 Days", key: "due_within_7_days", value: "--" },
            { label: "Crossed Due Date", key: "crossed_due_date", value: "--" },
        ])
        setCheckwiseStatusList([])
    }

    const toDoReport = async (serviceName, subServiceName) => {
        setToDoLoading(true);
        setToDoReportError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                service_id: serviceName?.value,
                service_sub_id: subServiceName?.value,
                action: "to_do_list_report"
            };

            // API call to fetch GST services
            const response = await postData(ORG_OVERVIEW_REPORT, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        // const responseDataObject = responseData?.dataJ[0] || {};
                        // const overViewReport = taskOverview.map((task) => ({
                        //     ...task,
                        //     value: responseDataObject[task.key] ?? "--",
                        // }));
                        const responseDataObject = responseData?.dataJ?.[0] || {};

                        // Ensure completed and pending exist as arrays
                        responseDataObject.completed = Array.isArray(responseDataObject.completed) ? responseDataObject.completed : [];
                        responseDataObject.pending = Array.isArray(responseDataObject.pending) ? responseDataObject.pending : [];

                        // ✅ Update `toDoListData` state with merged values
                        setToDoListData([
                            {
                                taskStatus: "Completed",
                                taskwise: responseDataObject.completed[0]?.task_wise,
                                fileNo: responseDataObject.completed[0]?.file_no,
                                without: "--" // Placeholder if needed
                            },
                            {
                                taskStatus: "Pending",
                                taskwise: responseDataObject.pending[0]?.task_wise,
                                fileNo: responseDataObject.pending[0]?.file_no,
                                without: "--"
                            }
                        ]);
                        // setTaskOverview(overViewReport);
                    } else {
                        setToDoReportError(responseData?.info || 'Task overview status failed.');
                        logFrontendException(storedUserId, pageName, "toDoReport", responseData?.info || '');
                    }
                } else {
                    setToDoReportError(responseData?.info || 'Unable to fetch task overview');
                    logFrontendException(storedUserId, pageName, "toDoReport", responseData?.info || '');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                
                    setToDoReportError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "toDoReport", responseData || '');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
               
                setIsLoginPopup(true)
            }
    
            // Unexpected or network-related errors
            else {
                setToDoReportError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "toDoReport", responseData || '');
            }
        } catch (error) {
            
                setToDoReportError(`Failed to get task overview. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "toDoReport-catch", error || '');
            
        } finally {
            setToDoLoading(false);
        }
    }

    const handleUserWiseReport = (type) => {
        console.log('selectedService', selectedService?.value);
        // if (userPermissions?.services?.per_name_sub_json?.view_task === 1) {
            const selectedInfo = {
                selService: selectedService || null,
                selServiceCategory: selectedServiceCategory || null,
                taskType: type || '',
                serviceCheckId: 0,
                completedChecks: selectedTaskCheck,
                pendingChecks: selectedTaskCheck2,
            }
            navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
        // }
    }

    const handleOverallReport = (type) => {
        console.log('selectedService', selectedService?.value);
        // if (userPermissions?.services?.per_name_sub_json?.view_task === 1) {
            const selectedInfo = {
                selService: selectedService || null,
                selServiceCategory: selectedServiceCategory || null,
                taskType: type || '',
                serviceCheckId: 0,
                completedChecks: selectedOverallStatus,
                pendingChecks: selectedOverallCheck,
                financialPeriod: selectedOverallPeriod,
                financialYear: selectedOverallYear,
            }
            navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
        // }
    }

    return {
        userPermissions,
        serviceOptions,
        serviceSubOptions,
        statusOptions,
        taskOverview,
        loading,
        handlePendingTask, handleCheckwise, handleSchedule,
        servicesLoading,
        servicesError,
        serviceName,
        setServiceName,
        subServiceName,
        setSubServiceName,
        subServicesLoading,
        subServicesError,
        handleSubServices,
        handleData,
        overViewLoading,
        overViewReportError,
        taskStatus,
        taskStatusLoading,
        taskStatusError,
        dateStatus,
        dateStatusLoading,
        dateStatusError,
        checkwiseStatus,
        checkwiseStatusLoading,
        checkwiseStatusError,
        scheduleInfoList,
        scheduleLoading,
        scheduleResError,
        scheduleInfoListLoading,
        checkwiseStatusList,
        notificationList,
        notificationError,
        notificationLoading,
        handleFinancialYear,
        cards,
        cards1,
        toDoListData,
        handleTaskwise,
        cards2, handleUserWiseReport,
        cards3, taskCheckList, taskCheckLoading, taskCheckError,
        count, countError, countLoading,
        handleOverallReport,
        toDoReportError, toDoLoading,
        handleToDoNavigation
    };
};

export default GstServiceController;

